import { render } from "./Archives.vue?vue&type=template&id=4a95f964&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"

import "./Archives.vue?vue&type=style&index=0&id=4a95f964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a95f964"]])

export default __exports__